import Seo from "@/components/feature/Seo";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import ContactForm from "@/pages/about/components/ContactForm";
import { principles, siteInfo } from "@/mocks/site";

const testimonials = [
  {
    quote:
      "以前看到群里转发的消息只会跟着着急，现在会先来这里搜一下有没有对应事件，很多时候已经有结论了。",
    name: "周女士",
    role: "社区志愿者",
  },
  {
    quote:
      "时间线做得很清楚，哪一步是爆料、哪一步是官方回应一眼就能看明白，比刷短视频省心多了。",
    name: "陈先生",
    role: "内容编辑",
  },
  {
    quote:
      "我最看重的是每条结论都列了来源。就算不完全认同，也能顺着来源自己去核对。",
    name: "林同学",
    role: "在校学生",
  },
];

const milestones = [
  { value: "1,286", label: "累计核验事件", desc: "涵盖社区生活、食品安全、交通出行等常见场景" },
  { value: "327", label: "反转案例归档", desc: "完整保留从爆料到结论的时间线" },
  { value: "7×24", label: "信息巡检", desc: "对高热传言保持持续跟踪与更新" },
];

export default function AboutPage() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: `关于我们 - ${siteInfo.fullName}`,
      url: `${siteInfo.url}/about`,
      inLanguage: "zh-CN",
      description:
        "了解棱镜求证的内容定位、发展理念、求证原则与联系方式。我们围绕社会爆料反转、官方回应与辟谣核验持续输出。",
    },
    {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      name: "联系方式与线索提交",
      url: `${siteInfo.url}/about#contact`,
      inLanguage: "zh-CN",
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: siteInfo.name,
      url: siteInfo.url,
      email: siteInfo.email,
      description: siteInfo.description,
    },
  ];

  return (
    <>
      <Seo
        title="关于我们｜棱镜求证的内容定位与求证原则 - 棱镜求证"
        description="棱镜求证专注社会爆料核验：了解我们的内容定位、发展理念、求证原则、用户口碑与联系方式，欢迎提交线索与指正内容。"
        keywords="关于棱镜求证,社会爆料核验,求证原则,真相核验"
        path="/about"
        jsonLd={jsonLd}
      />

      <section className="w-full border-b border-background-200 bg-background-100">
        <div className="mx-auto w-full max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
          <Breadcrumbs items={[{ label: "关于我们", path: "/about" }]} />
          <h1 className="mt-5 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            关于棱镜求证
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            一束光穿过棱镜会分成不同的颜色，一条爆料经过不同视角的核验，才会显出原本的样子。
            我们把这件事做成了一套持续运转的方法。
          </p>
        </div>
      </section>

      <section className="w-full bg-background-50 py-14 md:py-20">
        <div className="mx-auto grid w-full max-w-[1240px] grid-cols-1 items-center gap-10 px-4 md:px-6 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-6">
            <div className="w-full overflow-hidden rounded-lg border border-background-200">
              <div className="h-64 w-full bg-background-200 md:h-96">
                <img
                  src="https://readdy.ai/api/search-image?query=Editorial%20still%20life%20photograph%20of%20a%20glass%20prism%20and%20a%20magnifying%20glass%20resting%20on%20a%20warm%20linen%20surface%2C%20soft%20natural%20window%20light%2C%20muted%20earthy%20and%20amber%20tones%2C%20calm%20thoughtful%20mood%2C%20high%20detail%2C%20no%20text%2C%20refined%20editorial%20composition&width=1200&height=900&seq=about-lens-01&orientation=landscape"
                  alt="棱镜与放大镜置于暖色布面，象征对信息的多角度核验"
                  title="关于棱镜求证 · 内容定位与求证原则"
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
              <span className="h-[2px] w-6 bg-primary-500" aria-hidden="true" />
              Who We Are
            </div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              品牌介绍与网站定位
            </h2>
            <div className="mt-5 space-y-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              <p>
                棱镜求证是一个以核验为核心的爆料信息整理站。我们不生产爆料，也不以传播情绪为目标，
                而是把已经被公开讨论的事件按同一起事件重新聚合，还原它从发生到回应的完整过程。
              </p>
              <p>
                网站定位很明确：做人们转发之前的那一次停顿。无论是疑似谣言、正在反转的爆料，
                还是已经出现的官方回应，都能在这里找到对应的时间线与结论，并看到结论背后的依据。
              </p>
              <p>
                我们的发展理念是“可核对比可信更重要”。与其让你相信我们的判断，不如把判断所依赖的材料摆出来，
                让你自己复核。这也是我们坚持标注更新时间与参考来源的原因。
              </p>
            </div>

            <dl className="mt-8 grid grid-cols-1 gap-4 border-t border-background-200 pt-6 sm:grid-cols-3">
              {milestones.map((item) => (
                <div key={item.label}>
                  <dd className="font-label text-2xl font-semibold text-primary-600">{item.value}</dd>
                  <dt className="mt-1 text-sm font-medium text-foreground-900">{item.label}</dt>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-500">{item.desc}</p>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </section>

      <section className="w-full bg-background-100 py-14 md:py-20">
        <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
          <div className="max-w-2xl">
            <div className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">
              <span className="h-[2px] w-6 bg-accent-500" aria-hidden="true" />
              Content Principles
            </div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              内容原则
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              这四条原则决定了我们做什么、不做什么。它们不是口号，而是每一条内容在发布前都会走一遍的检查项。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {principles.map((item) => (
              <div
                key={item.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-400"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-800" aria-hidden="true">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full bg-background-50 py-14 md:py-20">
        <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
          <div className="mb-8 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <div className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-secondary-600">
                <span className="h-[2px] w-6 bg-secondary-500" aria-hidden="true" />
                User Voices
              </div>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                用户怎么说
              </h2>
            </div>
            <p className="max-w-md text-sm leading-relaxed text-foreground-600">
              以下反馈来自用户通过表单与邮件提交的真实留言，已做匿名与脱敏处理。
            </p>
          </div>

          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            {testimonials.map((item) => (
              <figure
                key={item.name}
                className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-6"
              >
                <span className="flex h-8 w-8 items-center justify-center text-accent-500" aria-hidden="true">
                  <i className="ri-double-quotes-l text-2xl" />
                </span>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  {item.quote}
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-secondary-800" aria-hidden="true">
                    {item.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-950">{item.name}</span>
                    <span className="block text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section id="contact" className="w-full scroll-mt-28 border-t border-background-200 bg-background-100 py-14 md:py-20">
        <div className="mx-auto grid w-full max-w-[1240px] grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <div className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
              <span className="h-[2px] w-6 bg-primary-500" aria-hidden="true" />
              Contact
            </div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              联系方式
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              如果你看到拿不准的信息，或发现我们已有内容存在错误，欢迎随时告诉我们。
              我们会认真核对每一条反馈。
            </p>

            <ul className="mt-7 space-y-4">
              <li className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700" aria-hidden="true">
                  <i className="ri-mail-line text-base" />
                </span>
                <span>
                  <span className="block text-sm font-semibold text-foreground-950">邮箱</span>
                  <a href={`mailto:${siteInfo.email}`} className="mt-0.5 block text-sm text-primary-600 hover:text-primary-700">
                    {siteInfo.email}
                  </a>
                </span>
              </li>
              <li className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-800" aria-hidden="true">
                  <i className="ri-time-line text-base" />
                </span>
                <span>
                  <span className="block text-sm font-semibold text-foreground-950">服务时间</span>
                  <span className="mt-0.5 block text-sm text-foreground-600">{siteInfo.workingHours}</span>
                </span>
              </li>
              <li className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800" aria-hidden="true">
                  <i className="ri-timer-line text-base" />
                </span>
                <span>
                  <span className="block text-sm font-semibold text-foreground-950">回复时效</span>
                  <span className="mt-0.5 block text-sm text-foreground-600">{siteInfo.responseTime}</span>
                </span>
              </li>
            </ul>

            <p className="mt-6 rounded-lg border border-dashed border-background-300 bg-background-50 p-4 text-xs leading-relaxed text-foreground-500">
              请勿在表单中填写身份证号、银行卡号等个人敏感信息。涉及隐私的线索，我们会在核验时进行脱敏处理。
            </p>
          </div>

          <div className="lg:col-span-7">
            <ContactForm />
          </div>
        </div>
      </section>
    </>
  );
}